import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';
// import AuthInput from "../../../components/SelectedStore/PayStatement/AuthMember/AuthInput";
// import {
//   setSendEmp,
//   setSendDate,
//   setSendStoreSeq,
//   setPayKakaoIndex,
// } from "../../../redux/reducers/sendPay";
import './AuthForDetailPay.scss';
import useLoadingStore from 'zustands/useLoadingStore';
import { AxiosResponse } from 'axios';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';
import usePaystatementStore from 'zustands/usePaystatementStore';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

interface IAuth {
  STORE_SEQ: string | string[];
  DATE: string | string[];
  EMP_NAME: string | string[];
  PAY_INDEX: string | string[];
  PM_INDEX: string | string[];
}

// base64 값은 '+' 를 포함할 수 있다. URLSearchParams 는 '+' 를 공백으로 디코딩하므로
// 원본 쿼리 문자열에서 직접 꺼낸다. (미인코딩 링크의 '+' 와 인코딩 링크의 '%2B' 둘 다 지원)
const getRawQueryValue = (search: string, key: string) => {
  const prefix = `${key}=`;
  const raw =
    search
      .replace(/^\?/, '')
      .split('&')
      .find((param) => param.startsWith(prefix))
      ?.slice(prefix.length) ?? '';

  if (!raw.includes('%')) return raw;

  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

const regExp_birth = /^(([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1,2][0-9]|3[0,1])))$/;
const regExp_birth2 = /[1-4]{1}/;

const AuthMember = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const { setLoadingState } = useLoadingStore();
  const { setModalState } = useAlertConfirmStore();
  const { setSendPay } = usePaystatementStore();

  const { webApiNode } = useApi();
  const { checkErrorLog } = useErrorLog();

  const [AuthData, setAuthData] = useState<IAuth>({
    STORE_SEQ: '',
    DATE: '',
    EMP_NAME: '',
    PAY_INDEX: '',
    PM_INDEX: '',
  });
  const [AuthValue, setAuthValue] = useState({
    value_1: '',
    value_2: '',
  });

  const HandleAuthInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (isNaN(Number(value))) {
      setModalState({
        isModalShow: true,
        title: '급여명세서 조회하기',
        desc: `올바른 값을 입력해 주세요`,
      });
      setAuthValue({
        ...AuthValue,
        [name]: '',
      });
    } else {
      setAuthValue({
        ...AuthValue,
        [name]: value,
      });
      if (value.length == 6) {
        if (InputFrontRef.current) InputFrontRef.current.focus();
      }
    }
  };

  const AuthNumber = async (value: any) => {
    if (!regExp_birth.test(value.value_1)) {
      return setModalState({
        isModalShow: true,
        title: '급여명세서 조회하기',
        desc: `올바른 생년월일 형식을 입력해 주세요`,
      });
    }
    // if (!regExp_birth2.test(value.value_2)){
    //     handlePopUp(true, `급여명세서 조회하기`, '올바른 생년월일을 뒷자리 형식을 입력해 주세요.', '', '닫기', null, false)
    //     return;
    // }
    // if (!regExp_birth2.test(value.value_2)){
    //     handlePopUp(true, `급여명세서 조회하기`, '급여정보가 없습니다.', '', '닫기', null, false)
    //     return;
    // }

    try {
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode(
        'post',
        // `/auth/${isMobile ? 'CertificagtePayKakaoApp' : 'CertificagtePayKakao'}`,
        // isMobile
        //   ? {
        //       MEMBER_BIRTH: value.value_1,
        //       s: AuthData.STORE_SEQ,
        //       d: AuthData.DATE,
        //       n: AuthData.EMP_NAME,
        //       i: AuthData.PAY_INDEX,
        //     }
        //   : {
        //       MEMBER_BIRTH: value.value_1,
        //       d: AuthData.DATE,
        //       n: AuthData.EMP_NAME,
        //       i: AuthData.PAY_INDEX,
        //     },
        `/auth/CertificagtePayKakaoApp`,
        {
          MEMBER_BIRTH: value.value_1,
          s: AuthData.STORE_SEQ,
          d: AuthData.DATE,
          n: AuthData.EMP_NAME,
          i: AuthData.PAY_INDEX,
          p: AuthData.PM_INDEX,
        },
      );

      if (data.resultCode === 0) {
        if (data.resultData.MEMBER_INDEX == '' || data.resultData.SELECT_DATE == '') {
          return setModalState({
            isModalShow: true,
            title: '급여명세서 조회하기',
            desc: `정확한 생년월일을 입력해 주세요`,
          });
        } else {
          setSendPay({
            sendDate: moment(data.resultData.SELECT_DATE).toDate(),
            acceptEmpSeq: data.resultData.MEMBER_INDEX,
            payStoreSeq: data.resultData.STORE_SEQ,
            payKakaoSeq: data.resultData.PK_INDEX,
          });
          navigate('/salary-detail', {
            state: {
              fromType: '0',
            },
          });
        }
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/CertificagtePayKakao');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const SetAuthData = () => {
    // 쿼리 값을 인코딩 여부와 무관하게 원본 base64 문자열로 복원한다.
    const s = getRawQueryValue(search, 's');
    const d = getRawQueryValue(search, 'd');
    const n = getRawQueryValue(search, 'n');
    const i = getRawQueryValue(search, 'i');
    const p = getRawQueryValue(search, 'p');

    if (s && d && n) {
      setAuthData({
        STORE_SEQ: s,
        DATE: d,
        EMP_NAME: n,
        PAY_INDEX: i,
        PM_INDEX: p,
      });
    }
  };

  useEffect(() => {
    SetAuthData();
  }, [search]);

  const InputFrontRef = useRef<HTMLInputElement>(null);
  const InputBackRef = useRef<HTMLInputElement>(null);

  return (
    <div className="AuthMember">
      <div className="AMDescArea">
        <strong>급여명세서</strong>
        <span>샵솔</span>
        <div className="AMDImg">
          <img
            src={require('assets/images/authMember.png')}
            alt="authMember Image"
            width="149"
            height="112"
            // objectFit={"contain"}
          />
        </div>
      </div>
      <div className="AMInputArea">
        <div className="AMInputTitle">급여명세서 조회하기</div>
        <div className="AMInput">
          <input
            ref={InputFrontRef}
            type="text"
            className="AMInputFront"
            name="value_1"
            value={AuthValue.value_1}
            onChange={HandleAuthInput}
            maxLength={6}
            placeholder="생년월일 6자리"
          />
          {/* <i>-</i>
                <input
                    ref={InputBackRef}
                    type="text"
                    className="AMInputBack"
                    name="value_2"
                    value={AuthValue.value_2}
                    onChange={HandleAuthInput}
                    maxLength={1}
                    placeholder="1자리"
                /> */}
        </div>
        <div className="AMInputBtn">
          <button onClick={() => AuthNumber(AuthValue)}>조회하기</button>
        </div>
      </div>
    </div>
  );
};

export default AuthMember;
